export const DEFAULT_SORT = [
  { colId: 'status', sort: 'asc' },
  { colId: 'cohort', sort: 'asc' },
  { colId: 'studentName', sort: 'asc' },
];
